<template>
    <div class="id-card-verification-intro">
        <div class="instruction-important">
            {{ `${$t('we do not want you to lose your account and money')}!` | capitalize }}
        </div>
        <div class=instruction>
            <!-- eslint-disable-next-line -->
            <span v-html="$t('kyc.intro')"></span>
        </div>
        <div
            class="instruction"
            v-if="isWithdrawal"
        >
            {{ $t('you will be able to withdraw the funds after completing the verification process' +
                ' (after approximately 24 hours)') | capitalize }}
        </div>
        <div
            v-if="daysRemaining"
            class="time-remaining mt-6 mb-6"
        >
            <div class="time-remaining__label">
                <i class="icon icon-time_sand_watch" />
                <div class="time-remaining__label__text">
                    {{ `${$t('time remaining')}:` | capitalize }}
                </div>
            </div>
            <div class="time-remaining__amount">
                {{ daysRemaining }} {{ $t('days') }}
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'Intro',
        props: {
            isWithdrawal: {
                type: Boolean,
                required: false,
            },
            daysRemaining: {
                type: Number,
                required: false,
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/userProfile/idCardVerification/components/Intro.vue